<template>
  <div>
    <!-- 自定义配置模式 -->
    <el-card class="box-card" v-show="isCustomConfigModeShown">
      <div slot="header" class="clearfix">
        <span>{{ $t('messageAdd.custom.001') }}</span>
        <span style="color: red">{{ $t('messageAdd.custom.002') }}</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">{{ $t('messageAdd.custom.003') }}</el-button> -->
      </div>
      <div class="card-custombox">
        <!-- 左侧 -->
        <el-table :data="tableData" border class="card-left">
          <el-table-column prop="setInfo" :label="$t('messageAdd.custom.004')" width="200">
          </el-table-column>
          <el-table-column prop="info" :label="$t('messageAdd.custom.005')">
          </el-table-column>
          <el-table-column :label="$t('messageAdd.custom.006')" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="mini"
                circle
                @click="addPageName(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 右侧 -->
        <el-card shadow="never" class="card-right">
          <div slot="header" class="clearfix">
            <div class="customConfigMode-title">
              <span>{{ $t('messageAdd.custom.007') }}{{ pages.length }}/{{ tableData.length }}</span>
              <el-button type="text" style="margin-left: 10px" @click="clearConfig" >{{ $t('messageAdd.custom.008') }}</el-button>
              <span class="card-titleTips">{{ $t('messageAdd.custom.009') }}</span>
            </div>
          </div>
          <!-- 页面配置顺序区域 -->
          <div class="drag-box">
            <draggable v-model="pages" :options="{ group: 'people' }">
              <div class="draggable-item" v-for="e in pages" :key="e.name">
                <span> {{ e.name }}</span>
                <el-button
                  type="primary"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="removePageName(e.name)"
                ></el-button>
              </div>
            </draggable>
          </div>
        </el-card>
      </div>
      <!-- 底部确认按钮 -->
      <div class="card-btns">
        <el-button @click="cancelConfig">{{ $t('messageAdd.custom.010') }}</el-button>
        <el-button type="primary" @click="submitConfig">{{ $t('messageAdd.custom.011') }}</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
// 使用拖拽组件
import draggable from "vuedraggable";
export default {
  data() {
    return {
      dialogVisible: true,
      pages: [],
      isCustomConfigModeShown: true,
    };
  },
  components: {
    draggable,
  },
  computed: {
    tableData() {
      return [
        {
          setInfo: this.$t("messageAdd.custom.012"),
          info: this.$t("messageAdd.custom.013"),
          pageName: "wifi",
        },
        {
          setInfo: this.$t("messageAdd.custom.014"),
          info: this.$t("messageAdd.custom.015"),
          pageName: "manageFileCert",
        },
        {
          setInfo: this.$t("messageAdd.custom.016"),
          info: this.$t("messageAdd.custom.017"),
          pageName: "displaySet",
        },
        {
          setInfo: this.$t("messageAdd.custom.018"),
          info: this.$t("messageAdd.custom.019"),
          pageName: "mobileNet",
        },
        {
          setInfo: this.$t("messageAdd.custom.020"),
          info: this.$t("messageAdd.custom.021"),
          pageName: "GeneralSet",
        },
        {
          setInfo: this.$t("messageAdd.custom.022"),
          info: this.$t("messageAdd.custom.023"),
          pageName: "launcherSet",
        },
        {
          setInfo: this.$t("messageAdd.custom.024"),
          info: this.$t("messageAdd.custom.025"),
          pageName: "sound",
        },
        {
          setInfo: this.$t("messageAdd.custom.026"),
          info: this.$t("messageAdd.custom.027"),
          pageName: "timeSet",
        },
        {
          setInfo: this.$t("messageAdd.custom.028"),
          info: this.$t("messageAdd.custom.029"),
          pageName: "USBSet",
        },
        {
          setInfo: this.$t("messageAdd.custom.030"),
          info: this.$t("messageAdd.custom.031"),
          pageName: "manageApp",
        },
        {
          setInfo: this.$t("messageAdd.custom.032"),
          info: this.$t("messageAdd.custom.033"),
          pageName: "featuredSet",
        },
        {
          setInfo: this.$t("messageAdd.custom.034"),
          info: this.$t("messageAdd.custom.035"),
          pageName: "scanningTool",
        },
        {
          setInfo: "Data Wedge APP",
          info: this.$t("messageAdd.custom.036"),
          pageName: "dataWedge",
        },
        {
          setInfo: this.$t("messageAdd.custom.042"),
          info: this.$t("messageAdd.custom.043"),
          pageName: "mobileButler",
        },
        {
          setInfo: this.$t("messageAdd.custom.044"),
          info: this.$t("messageAdd.custom.045"),
          pageName: "shortCutKey",
        },
      ];
    },
  },
  methods: {
    // 检查 pages 数组中是否已存在具有相同 name 或 pageName 的对象
    isPageExists(data) {
      return this.pages.some((page) => {
        return page.name === data.name || page.pageName === data.pageName;
      });
    },
    addPageName(data) {
      if (!this.isPageExists(data)) {
        this.pages.push({
          name: data.setInfo,
          pageName: data.pageName,
        });
      } else {
        // 如果已存在，可以输出一个警告或进行其他处理
        this.$message.closeAll();
        this.$message.error(this.$t("messageAdd.custom.037"));
      }
    },
    removePageName(name) {
      // 使用filter方法来创建一个新的数组，不包含要删除的对象
      this.pages = this.pages.filter((page) => page.name !== name);
    },
    // 确认按钮
    submitConfig() {
      if (this.pages.length == 0) {
        this.$message.closeAll();
        this.$message.error(this.$t("messageAdd.custom.038"));
        return;
      } else {
        this.$router.push({ name: "CustomConfigModeChildPage", params: { pages: this.pages } });
        localStorage.removeItem("config-wifi");
        localStorage.removeItem("config-mobileNet");
        localStorage.removeItem("config-launcher");
        localStorage.removeItem("config-displaySet");
        localStorage.removeItem("config-sound");
        localStorage.removeItem("config-timeSet");
        localStorage.removeItem("config-USBSet");
        localStorage.removeItem("config-GeneralSet");
        localStorage.removeItem("config-featuredSetFilter");
        localStorage.removeItem("config-featuredSetNoFilter");
        localStorage.removeItem("config-scanToolDataNoFilter");
        localStorage.removeItem("config-scanToolDataFilter");
        localStorage.removeItem("config-appSettingDataNoFilter");
        localStorage.removeItem("config-appSetDataFilter");
        localStorage.removeItem("mf");
        localStorage.removeItem("ma");
        localStorage.removeItem("config-dataWedgeApp");
        localStorage.removeItem("config-editableTabs");
        localStorage.removeItem("config-mobileButler");
        localStorage.removeItem("config-shortCutKey");
      }
    },
    // 取消按钮
    cancelConfig() {
      if (this.pages.length == 0) {
        this.$message.error(this.$t("messageAdd.custom.038"));
      } else {
        this.pages = [];
      }
    },
    // 清空页面配置
    clearConfig() {
      this.pages = [];
    },
  },
};
</script>
